/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AlertesService } from './services/alertes.service';
import { StatistiquesApiService } from './services/statistiques-api.service';
import { ApportsVisiteService } from './services/apports-visite.service';
import { ArticlesCommandesService } from './services/articles-commandes.service';
import { ArticlesService } from './services/articles.service';
import { AuthentificationService } from './services/authentification.service';
import { BelgesService } from './services/belges.service';
import { CategoriesDocumentsService } from './services/categories-documents.service';
import { CategoriesTypesEvacuationsService } from './services/categories-types-evacuations.service';
import { ClesApiService } from './services/cles-api.service';
import { CodesPostauxService } from './services/codes-postaux.service';
import { CommandesService } from './services/commandes.service';
import { CommentairesRapportsPreposesService } from './services/commentaires-rapports-preposes.service';
import { ConteneursService } from './services/conteneurs.service';
import { ConteneursFixesService } from './services/conteneurs-fixes.service';
import { ConteneursMobilesService } from './services/conteneurs-mobiles.service';
import { CotisationsBelgesHorsZoneIcService } from './services/cotisations-belges-hors-zone-ic.service';
import { CotisationsEtrangersService } from './services/cotisations-etrangers.service';
import { DashboardsService } from './services/dashboards.service';
import { DemandesEvacuationService } from './services/demandes-evacuation.service';
import { DemandesQuotasSupplementairesPersonneMoraleService } from './services/demandes-quotas-supplementaires-personne-morale.service';
import { DemandesQuotasSupplementairesPersonnePhysiqueService } from './services/demandes-quotas-supplementaires-personne-physique.service';
import { DemandesTransportService } from './services/demandes-transport.service';
import { DestinationEvacuationService } from './services/destination-evacuation.service';
import { DestinationTransportService } from './services/destination-transport.service';
import { DetailEvacuationService } from './services/detail-evacuation.service';
import { DetailsRelevesCompteursService } from './services/details-releves-compteurs.service';
import { DispatchExutoireService } from './services/dispatch-exutoire.service';
import { DispatchTransporteurService } from './services/dispatch-transporteur.service';
import { DocumentsService } from './services/documents.service';
import { ElementsNettoyagesService } from './services/elements-nettoyages.service';
import { EmplacementsStockService } from './services/emplacements-stock.service';
import { EntretienService } from './services/entretien.service';
import { EtatsStockService } from './services/etats-stock.service';
import { EtrangersService } from './services/etrangers.service';
import { ExutoiresService } from './services/exutoires.service';
import { FermeturesExceptionnellesRecyparcsService } from './services/fermetures-exceptionnelles-recyparcs.service';
import { FermeturesTemporairesRecyparcsService } from './services/fermetures-temporaires-recyparcs.service';
import { FichesControlesService } from './services/fiches-controles.service';
import { FormesJuridiquesService } from './services/formes-juridiques.service';
import { FormulairesCitoyensService } from './services/formulaires-citoyens.service';
import { FormulairesService } from './services/formulaires.service';
import { HeuresOuvertureRecyparcsService } from './services/heures-ouverture-recyparcs.service';
import { IncidentsService } from './services/incidents.service';
import { InterventionsService } from './services/interventions.service';
import { InterventionsTechniquesService } from './services/interventions-techniques.service';
import { JokersPersonnesPhysiquesService } from './services/jokers-personnes-physiques.service';
import { JoursFermetureGlobaleService } from './services/jours-fermeture-globale.service';
import { MaterielRecyparcsService } from './services/materiel-recyparcs.service';
import { MatieresAPointerService } from './services/matieres-a-pointer.service';
import { MatieresAQuotaService } from './services/matieres-a-quota.service';
import { MatieresARetraitService } from './services/matieres-a-retrait.service';
import { MouvementStockService } from './services/mouvement-stock.service';
import { NettoyagesService } from './services/nettoyages.service';
import { NumerosSpeciauxService } from './services/numeros-speciaux.service';
import { PanelService } from './services/panel.service';
import { ParcsService } from './services/parcs.service';
import { ParcsLimitrophesRecyparcsService } from './services/parcs-limitrophes-recyparcs.service';
import { ParcMobilePdaService } from './services/parc-mobile-pda.service';
import { PaysService } from './services/pays.service';
import { PermissionsService } from './services/permissions.service';
import { PersonnesMoralesService } from './services/personnes-morales.service';
import { PersonnesPhysiquesService } from './services/personnes-physiques.service';
import { PersonnesPhysiquesPlaquesService } from './services/personnes-physiques-plaques.service';
import { PersonnesPhysiquesSecondeResidenceService } from './services/personnes-physiques-seconde-residence.service';
import { PhotosPdaService } from './services/photos-pda.service';
import { PictogrammesService } from './services/pictogrammes.service';
import { PingService } from './services/ping.service';
import { PlanningsEvacuationService } from './services/plannings-evacuation.service';
import { PlaquesPersonnePhysiqueService } from './services/plaques-personne-physique.service';
import { PlaquesEtrangerService } from './services/plaques-etranger.service';
import { PlaquesPersonneMoraleService } from './services/plaques-personne-morale.service';
import { RapportIncidentService } from './services/rapport-incident.service';
import { RapportsManagersService } from './services/rapports-managers.service';
import { RapportsPreposesService } from './services/rapports-preposes.service';
import { RelevesCompteursService } from './services/releves-compteurs.service';
import { ReparationsConteneursService } from './services/reparations-conteneurs.service';
import { RetraitsVisiteService } from './services/retraits-visite.service';
import { RolesService } from './services/roles.service';
import { SecondesResidencesService } from './services/secondes-residences.service';
import { SecondesResidencesPersonnePhysiqueService } from './services/secondes-residences-personne-physique.service';
import { ClientsSignalRService } from './services/clients-signal-r.service';
import { StocksService } from './services/stocks.service';
import { TelephonesRecyparcsService } from './services/telephones-recyparcs.service';
import { TestService } from './services/test.service';
import { ThemesService } from './services/themes.service';
import { TontesService } from './services/tontes.service';
import { ToolsService } from './services/tools.service';
import { TransporteursService } from './services/transporteurs.service';
import { TypesAccesPersonnesMoralesService } from './services/types-acces-personnes-morales.service';
import { TypesConteneursMobilesService } from './services/types-conteneurs-mobiles.service';
import { TypesControlesService } from './services/types-controles.service';
import { TypesDechetsService } from './services/types-dechets.service';
import { TypesDechetsRecyparcsService } from './services/types-dechets-recyparcs.service';
import { TypesDechetsRwService } from './services/types-dechets-rw.service';
import { TypesElementsStockService } from './services/types-elements-stock.service';
import { TypesEvacuationsService } from './services/types-evacuations.service';
import { TypesEvacuationRecyparcsService } from './services/types-evacuation-recyparcs.service';
import { TypesIncidentsService } from './services/types-incidents.service';
import { TypesInterventionsTechniquesService } from './services/types-interventions-techniques.service';
import { TypesReparationsService } from './services/types-reparations.service';
import { UnitesMesureService } from './services/unites-mesure.service';
import { UtilisateursService } from './services/utilisateurs.service';
import { VisitesService } from './services/visites.service';
import { VisitesPdaService } from './services/visites-pda.service';
import { WebhooksService } from './services/webhooks.service';
import { ZonesGeographiquesService } from './services/zones-geographiques.service';
import { PluginBepService } from './services/plugin-bep.service';
import { PluginIdeluxService } from './services/plugin-idelux.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AlertesService,
    StatistiquesApiService,
    ApportsVisiteService,
    ArticlesCommandesService,
    ArticlesService,
    AuthentificationService,
    BelgesService,
    CategoriesDocumentsService,
    CategoriesTypesEvacuationsService,
    ClesApiService,
    CodesPostauxService,
    CommandesService,
    CommentairesRapportsPreposesService,
    ConteneursService,
    ConteneursFixesService,
    ConteneursMobilesService,
    CotisationsBelgesHorsZoneIcService,
    CotisationsEtrangersService,
    DashboardsService,
    DemandesEvacuationService,
    DemandesQuotasSupplementairesPersonneMoraleService,
    DemandesQuotasSupplementairesPersonnePhysiqueService,
    DemandesTransportService,
    DestinationEvacuationService,
    DestinationTransportService,
    DetailEvacuationService,
    DetailsRelevesCompteursService,
    DispatchExutoireService,
    DispatchTransporteurService,
    DocumentsService,
    ElementsNettoyagesService,
    EmplacementsStockService,
    EntretienService,
    EtatsStockService,
    EtrangersService,
    ExutoiresService,
    FermeturesExceptionnellesRecyparcsService,
    FermeturesTemporairesRecyparcsService,
    FichesControlesService,
    FormesJuridiquesService,
    FormulairesCitoyensService,
    FormulairesService,
    HeuresOuvertureRecyparcsService,
    IncidentsService,
    InterventionsService,
    InterventionsTechniquesService,
    JokersPersonnesPhysiquesService,
    JoursFermetureGlobaleService,
    MaterielRecyparcsService,
    MatieresAPointerService,
    MatieresAQuotaService,
    MatieresARetraitService,
    MouvementStockService,
    NettoyagesService,
    NumerosSpeciauxService,
    PanelService,
    ParcsService,
    ParcsLimitrophesRecyparcsService,
    ParcMobilePdaService,
    PaysService,
    PermissionsService,
    PersonnesMoralesService,
    PersonnesPhysiquesService,
    PersonnesPhysiquesPlaquesService,
    PersonnesPhysiquesSecondeResidenceService,
    PhotosPdaService,
    PictogrammesService,
    PingService,
    PlanningsEvacuationService,
    PlaquesPersonnePhysiqueService,
    PlaquesEtrangerService,
    PlaquesPersonneMoraleService,
    RapportIncidentService,
    RapportsManagersService,
    RapportsPreposesService,
    RelevesCompteursService,
    ReparationsConteneursService,
    RetraitsVisiteService,
    RolesService,
    SecondesResidencesService,
    SecondesResidencesPersonnePhysiqueService,
    ClientsSignalRService,
    StocksService,
    TelephonesRecyparcsService,
    TestService,
    ThemesService,
    TontesService,
    ToolsService,
    TransporteursService,
    TypesAccesPersonnesMoralesService,
    TypesConteneursMobilesService,
    TypesControlesService,
    TypesDechetsService,
    TypesDechetsRecyparcsService,
    TypesDechetsRwService,
    TypesElementsStockService,
    TypesEvacuationsService,
    TypesEvacuationRecyparcsService,
    TypesIncidentsService,
    TypesInterventionsTechniquesService,
    TypesReparationsService,
    UnitesMesureService,
    UtilisateursService,
    VisitesService,
    VisitesPdaService,
    WebhooksService,
    ZonesGeographiquesService,
    PluginBepService,
    PluginIdeluxService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
